import * as React from 'react';
import { LoadOptions, RequestApiMethod } from 'app/types-shared';
import { CodeSinglePicker } from '../../common';
import { MeasurementSystemProps } from './types';
import { isDefinedIncludingZero } from 'app/infrastructure/data/number';
import { endpoints } from 'app/area/codetable/item/endpoints';
import { codetableOptionsIds } from 'app/area/codetable/item/screen-renderer/screen-pickers/constants';
import { CodeFieldWireKey } from 'app/area/codetable/types-store';
import { CodeComplexValue } from 'app/area/shared/codetable/types';
import { ScreenPicker } from 'app/area/codetable/item/screen-renderer/types';
import { ReadOnlyType } from 'app/area/codetable/item/types';
import { manageOptionsButton } from 'app/area/shared/manage-options';

export const MeasurementSystem = (props: MeasurementSystemProps) => {

  const { breadcrumbs, metadata, codeItem, options, loadOptions, updateMeasurementSystem, translation, validation, readOnlyConfig } = props;

  const codetableId = !!metadata && !!metadata.codetable && isDefinedIncludingZero(metadata.codetable.id)
    ? metadata.codetable.id
    : undefined;

  const measurementSystemId = codetableOptionsIds[ScreenPicker.measurementSystem];
  const readOnly = readOnlyConfig && readOnlyConfig[ReadOnlyType.all];

  const onLoadOptions = (id: string, loadOptionsParams: LoadOptions) => {
    loadOptions(
      id,
      endpoints.optionsCollectionSearch(measurementSystemId),
      {
        ...loadOptionsParams,
        requestApiMethod: RequestApiMethod.post,

        ...{ displayNotSelected: false },
        ...{ apiVersion: '3.0' }
      }, { limitFieldsTo: [CodeFieldWireKey.code] });
  };

  const extraFooterButton = manageOptionsButton(translation.manage_options, measurementSystemId, breadcrumbs);

  const measurementSystemOptions = (!!options.measurementSystem && options.measurementSystem.codes || []) as CodeComplexValue<number>[];

  const measurementSystemValidation = !!validation && !!validation.measurementSystem ? validation.measurementSystem : undefined;

  return <CodeSinglePicker
    id="measurementSystem"
    label={translation.uom_measurement_system}
    valueItem={codeItem && codeItem.measurementSystem}
    searchRequired={codetableId && metadata.codetable.searchRequired}
    readOnly={readOnly}
    showBackgroundColour={true}
    options={measurementSystemOptions}
    fetchingOptions={options.measurementSystem && options.measurementSystem.fetching}

    translation={translation}
    validation={measurementSystemValidation}

    onLoadOptions={onLoadOptions}
    onChange={updateMeasurementSystem}
    extraFooterButton={extraFooterButton}
  />;
};
